import React, { Component } from 'react'
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStore } from '../../store';
import ReceptoresFileList from './files/list/ReceptoresFileList';
import SearchByDatesAndKeyword from '../../shared/SearchByDatesAndKeyword';
import ReceptoresFileItemActions from './files/list/components/ReceptoresFileItemActions';

class ReceptoresFile extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Receptores archivos');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  }

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to } = this.props.pagination;

    return (
      <>
        <Row>
          <Col sm="auto" md="8" className="mb-2">
            { selectedRowKeys.length > 0 && (
              <div className="mr-3 d-inline-flex pb-2">
                <ReceptoresFileItemActions
                  selectedRowKeys={ selectedRowKeys }
                  selectedRows={ selectedRows }
                  alignRight={ false }
                />
              </div>
            )}

            { selectedRowKeys.length === 0 && (
                <SearchByDatesAndKeyword
                  from={ from }
                  to={ to }
                  onDateChange={ this.handleOnDateChange }
                  onKeywordChange={ this.handleOnKeywordChange }
                />
              )}
          </Col>

          <Col sm="auto" md="4" className="text-right pb-2">
            { Guardian.allows('receptor.crear.excel') && (
              <Button as={ Link } className="mr-2" to="/app/receptores/upload">
                Subir archivo
              </Button>
            )}


            { Guardian.allows('receptor.listar.excel') && (
              <Button variant="link"
                as={ Link }
                className="text-secondary"
                to="/app/receptores/excel"
              >
                Receptores excel { ' ' }
                <FontAwesomeIcon icon={ ['fas', 'chevron-right'] } />
              </Button>
            )}
          </Col>
        </Row>

        { Guardian.allows('receptor.listar.archivos') && (
          <ReceptoresFileList
            selectedRowKeys={ selectedRowKeys }
            selectedRows={ selectedRows }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}
      </>
    )
  }
}

const mapState = (store) => {
  return store.app.receptores.archivos
}

const mapActions = (actions) => {
  return actions.app.receptores.archivos;
}

export default connect(useStore, mapState, mapActions)(ReceptoresFile);